module.exports = __webpack_public_path__ + "/86d620367024af32c9e8d59e9afbafa8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/clouds_box.svg
 ** module id = 847
 ** module chunks = 0
 **/